// frontend/src/hooks/use-theme-colors.js
import { useMemo } from "react";
import { getInterpolatedTheme } from "@/lib/themeInterpolation";

export function useThemeColors(themePosition) {
  return useMemo(() => {
    const theme = getInterpolatedTheme(themePosition);
    return {
      style: {
        background: theme.bg,
        "--aiv-bg": theme.bg,
        "--aiv-bg-solid": theme.bgSolid,
        "--aiv-surface": theme.surface,
        "--aiv-accent": theme.accent,
        "--aiv-text": theme.text,
        "--aiv-text-2": theme.text2,
        "--aiv-glass-bg": theme.glassBg,
        "--aiv-glass-border": theme.glassBorder,
      },
      heroFilter: theme.heroFilter,
    };
  }, [themePosition]);
}
